<div class="exception-body access">
    <div class="particle elem1 anim-delay1"></div>
    <div class="particle elem2 anim-delay5"></div>
    <div class="particle elem3 anim-delay3"></div>
    <div class="particle elem4 anim-delay8"></div>
    <div class="particle elem5 anim-delay9"></div>
    <div class="particle elem6 anim-delay2"></div>
    <div class="particle elem7 anim-delay4"></div>
    <div class="exception-panel">
        <div class="exception-panel-content">
            <h1>ACCESO</h1>
            <span class="secondary">DENEGADO</span>
            <div>
                <span><strong>No tienes los permisos necesarios para acceder al sitio web.</strong></span>
            </div>
        </div>
    </div>
</div>
